import { render, staticRenderFns } from "./SecondHomeItem.vue?vue&type=template&id=674e9aa1&"
import script from "./SecondHomeItem.vue?vue&type=script&lang=js&"
export * from "./SecondHomeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports